// extracted by mini-css-extract-plugin
export default {"page-layout":"VerifyPage_page-layout__t3jkC","container":"VerifyPage_container__Do++9","card":"VerifyPage_card__4VPRo","image":"VerifyPage_image__QzZgg"};